import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  topFigures: {
    position: 'relative',
    margin: '80px 0',
    zIndex: 1,
  },
  personWithCalculator: {
    position: 'relative',
    height: 501,
    marginLeft: 30,
  },
  cactus: {
    height: 180,
    bottom: 0,
    left: 258,
  },
  sofa: {
    height: 268,
    left: -15,
    bottom: 70,
  },
  serviceFigures: {
    position: 'relative',
    display: 'flex',
  },
  servicePerson: {
    position: 'relative',
    height: 273,
    marginLeft: 60,
    marginBottom: -25,
  },
  serviceCircleOne: {
    width: 540,
    height: 540,
    top: -887,
    left: '50%',
    transform: 'translateX(-50%)',
  },
  serviceCircleTwo: {
    height: 180,
    width: 180,
    bottom: -26,
    left: -150,
  },
  mailbox: {
    display: 'none',
  },
  probateCircleOne: {
    width: 128,
    height: 128,
    top: 386,
    left: -13,
  },
  probateCircleTwo: {
    width: 220,
    height: 220,
    right: -74,
    bottom: -178,
  },
  benefitsFigures: {
    display: 'none',
  },
  topSection: {
    paddingTop: 56,
    backgroundColor: theme.palette.background.default,
  },
  relative: {
    position: 'relative',
  },
  title: {
    marginBottom: 8,
  },
  startWillButton: {
    marginTop: 24,
  },
  blueDot: {
    color: theme.palette.primary.dark,
  },
  countrywide: {
    textAlign: 'center',
    paddingBottom: 24,

    '& img': {
      height: 48,
      marginBottom: 24,
    },
    '& br': {
      display: 'none',
    },
  },
  administrators: {
    backgroundColor: theme.palette.background.paper,
    padding: '40px 0',
    textAlign: 'center',

    '& p': {
      '&:first-child': {
        marginBottom: 16,
      },
      '&:nth-child(2)': {
        color: theme.palette.info.main,
      },
    },
  },
  serviceContent: {
    margin: '104px 0 45px',
    '& h3': {
      marginBottom: 16,
    },
  },
  executor: {
    backgroundColor: theme.palette.background.paper,
    padding: '40px 0',
  },
  executorsContent: {
    display: 'grid',
    rowGap: 56,

    '& h6': {
      marginBottom: 24,
    },
    '& p': {
      color: theme.palette.info.main,
    },
  },
  verticalBorder: {
    display: 'none',
    width: 2,
    backgroundColor: theme.palette.info.main,
    opacity: 0.3,
  },
  services: {
    padding: '80px 0',
  },
  servicesCard: {
    color: theme.palette.background.default,
    backgroundColor: theme.palette.background.default,
    borderRadius: 40,
    boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
    padding: 40,
    marginTop: 24,
    textAlign: 'center',
    display: 'grid',
    rowGap: 32,

    '& h6': {
      marginBottom: 8,
    },
    '& p': {
      color: theme.palette.info.main,
    },
  },
  serviceIcon: {
    backgroundColor: theme.palette.primary.dark,
    height: 88,
    width: 88,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    borderRadius: 24,
    fontSize: 48,
    color: theme.palette.background.default,
    boxShadow: '0px 10px 20px rgba(16, 113, 170, 0.25)',
  },
  benefits: {
    backgroundColor: theme.palette.background.paper,
    padding: '80px 0 40px',
  },
  benefit: {
    marginTop: 40,

    '& h6': {
      marginBottom: 16,
    },
    '& span': {
      color: theme.palette.secondary.dark,
    },
  },
  simpwillServices: {
    padding: '80px 0',
  },
  simpwillService: {
    marginTop: 40,

    '& h6': {
      color: theme.palette.info.main,
    },
  },
  SimpwillInnerData: {
    marginTop: 24,
    paddingLeft: 40,

    '& p': {
      '&:first-child': {
        marginBottom: 8,
      },
    },
  },
  support: {
    backgroundColor: theme.palette.background.paper,
    padding: '80px 0',
  },
  supportContent: {
    '& button': {
      marginTop: 24,
    },
  },
  [theme.breakpoints.up('sm')]: {
    topFigures: {
      position: 'absolute',
      margin: 0,
    },
    topCircle: {
      height: 698,
      width: 698,
      top: -33,
      left: 410,
    },
    personWithCalculator: {
      position: 'absolute',
      margin: 0,
      height: 450,
      top: 74,
      left: 400,
    },
    sofa: {
      height: 'initial',
      width: 476,
      top: 236,
      left: 264,
    },
    cactus: {
      bottom: 'initial',
      top: 370,
      left: 568,
    },
    serviceFigures: {
      position: 'absolute',
    },
    servicePerson: {
      position: 'absolute',
      margin: 0,
      left: 'initial',
      right: 50,
      bottom: -25,
      height: 'initial',
      width: 150,
    },
    serviceCircleOne: {
      width: 370,
      height: 370,
      top: -330,
    },
    serviceCircleTwo: {
      width: 127,
      height: 127,
      bottom: -63,
      left: -88,
    },
    probateCircleOne: {
      top: 234,
      left: 10,
    },
    probateCircleTwo: {
      width: 300,
      height: 300,
      bottom: 97,
      right: -172,
    },
    topSection: {
      padding: 0,
    },
    wishes: {
      width: 330,
      paddingTop: 100,
      paddingBottom: 236,
    },
    countrywide: {
      '& h3': {
        margin: '0 auto',
      },
      '& br': {
        display: 'block',
      },
    },
    serviceContent: {
      width: 450,
      margin: 0,
      padding: '80px 0',
    },
    executorsContent: {
      gridTemplateColumns: '1fr 1fr',
      columnGap: 30,
    },
    servicesCard: {
      gridTemplateColumns: '88px 1fr',
      columnGap: 16,
      textAlign: 'left',
    },
    benefit: { marginTop: 48 },
    support: {
      padding: '40px 0',
    },
    supportContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  [theme.breakpoints.up('md')]: {
    topCircle: {
      left: 766,
    },
    personWithCalculator: {
      height: 501,
      top: 17,
      left: 645,
    },
    sofa: {
      left: 740,
    },
    cactus: {
      top: 360,
      left: 882,
    },
    servicePerson: {
      height: 273,
      width: 'initial',
      right: 96,
    },
    serviceCircleOne: {
      width: 430,
      height: 430,
      top: -380,
    },
    probateCircleOne: {
      top: 206,
      left: 27,
    },
    probateCircleTwo: {
      display: 'none',
    },
    benefitsFigures: {
      display: 'block',
      zIndex: 0,
    },
    benefitPerson: {
      height: 634,
      top: 134,
      left: 50,
    },
    benefitCircle: {
      width: 698,
      height: 698,
      top: 108,
      left: -504,
    },
    wishes: {
      width: 600,
      paddingTop: 130,
      paddingBottom: 170,
    },
    title: {
      fontSize: 48,
      marginBottom: 24,
    },
    startWillButton: {
      marginTop: 40,
    },
    serviceContent: {
      width: 540,
      padding: '88px 0 40px',
    },
    executorsContent: {
      gridTemplateColumns: '1fr 2px 1fr',
      columnGap: 110,

      '& h6': {
        marginBottom: 40,
        fontSize: 32,
      },
    },
    verticalBorder: { display: 'block' },
    services: {
      padding: '88px 0',
    },
    benefits: {
      padding: '40px 0',

      '& br': {
        display: 'none',
      },
    },
    benefitContent: {
      width: 610,
      marginLeft: 'auto',
    },
    simpwillServices: {
      padding: '88px 0',
    },
    simpwillServicesContent: {
      display: 'grid',
      gridTemplateColumns: '1fr 2px 1fr',
      marginTop: 64,
      gap: '64px 16px',
    },
    SimpwillInnerData: {
      marginTop: 16,
    },
    simpwillService: {
      margin: 0,
    },
  },
  [theme.breakpoints.up('lg')]: {
    topCircle: {
      top: -46,
      left: 712,
    },
    personWithCalculator: {
      top: 25,
      left: 639,
    },
    sofa: { width: 640, left: 705, top: 218 },
    cactus: {
      top: 368,
      left: 880,
    },
    servicePerson: {
      height: 330,
      bottom: -35,
    },
    serviceCircleOne: {
      width: 650,
      height: 650,
      top: -575,
    },
    serviceCircleTwo: {
      width: 252,
      height: 252,
      top: 291,
      left: -252,
    },
    probateCircleTwo: {
      display: 'block',
      bottom: 160,
      right: -180,
    },
    mailbox: {
      display: 'block',
      height: 400,
      top: 230,
      right: -240,
    },
    serviceContent: {
      padding: '144px 0 40px',
    },
    services: { padding: '144px 0 80px' },
    servicesCards: {
      width: 920,
    },
    benefits: {
      padding: '80px 0',
    },
    benefitContent: {
      width: 635,
    },
    simpwillServices: {
      padding: '144px 0 80px',
    },
    simpwillServicesContent: {
      gap: '80px 42px',
      marginTop: 80,
    },
  },
}));

export default useStyles;
